export default __webpack_public_path__ + "static/media/bitrate-gallery.b4dffb14.png";